import * as types from './systemBannerActionType'

export const systemBannerFetch = (): types.SystemBannerFetch => ({
  type: types.SYSTEM_BANNER_FETCH,
})

export const systemBannerSet = (payload: { system: types.BannerItem | null; property: types.BannerItem | null }): types.SystemBannerSet => ({
  type: types.SYSTEM_BANNER_SET,
  payload,
})

export const systemBannerReset = (): types.SystemBannerReset => ({
  type: types.SYSTEM_BANNER_RESET,
})

export const systemBannerResetSystem = (): types.SystemBannerResetSystem => ({
  type: types.SYSTEM_BANNER_RESET_SYSTEM,
})

export const systemBannerResetProperty = (): types.SystemBannerResetProperty => ({
  type: types.SYSTEM_BANNER_RESET_PROPERTY,
})
